import { Link } from 'react-router-dom';
import type { NavNeighbor } from '../types/content';

interface TopicNavProps {
  hlSlug: string;
  specificSlug: string;
  prev: NavNeighbor | null;
  next: NavNeighbor | null;
}

export function TopicNav({ hlSlug, specificSlug, prev, next }: TopicNavProps) {
  if (!prev && !next) return null;

  const href = (item: NavNeighbor) =>
    `/issues/${hlSlug}/${specificSlug}/${item.slug}`;

  return (
    <nav className="topic-nav" aria-label="Topic sequence">
      {prev ? (
        <Link to={href(prev)} className="topic-nav-link topic-nav-prev">
          <span className="topic-nav-dir">← Previous</span>
          <span className="topic-nav-title">{prev.title}</span>
          <span className="topic-nav-pos">
            {prev.position} of {prev.total}
          </span>
        </Link>
      ) : (
        <div className="topic-nav-placeholder" />
      )}
      {next ? (
        <Link to={href(next)} className="topic-nav-link topic-nav-next">
          <span className="topic-nav-dir">Next →</span>
          <span className="topic-nav-title">{next.title}</span>
          <span className="topic-nav-pos">
            {next.position} of {next.total}
          </span>
        </Link>
      ) : (
        <div className="topic-nav-placeholder" />
      )}
    </nav>
  );
}
